<template>
  <div :id="componentId" class="sp2-module-6" :style="moduleStyle">
    <div class="sp2-module-6-content">
      <div class="sp2-carousel-arrow sp2-arrow-left" @click="prev">
        <i class="el-icon-arrow-left" />
      </div>

      <div class="sp2-carousel-list">
        <div
          v-for="(item, index) in displayList"
          :key="index"
          class="sp2-carousel-item"
          :class="{ active: activeIndex === index }"
          @click="setActive(index)"
        >
          <template v-if="activeIndex !== index">
            <div class="sp2-card-title-bg">
              <div class="sp2-card-title">{{ item.title || '标题' }}</div>
            </div>
            <div class="sp2-card-bar" />
            <div class="sp2-card-subtitle">{{ item.subtitle || '副标题' }}</div>
            <div class="sp2-card-meta">
              <div class="sp2-card-label">发布时间</div>
              <div class="sp2-card-time">{{ item.publishTime1 || '8月—11月' }}</div>
              <div class="sp2-card-label">发布时间</div>
              <div class="sp2-card-time">{{ item.publishTime2 || '12月20日' }}</div>
            </div>
          </template>
          <template v-else>
            <div class="sp2-card-image-wrap">
              <img
                v-if="item.imageUrl"
                class="sp2-card-image"
                referrerpolicy="no-referrer"
                :src="item.imageUrl"
              >
              <div v-else class="sp2-card-image-placeholder">请配置图片</div>
            </div>
            <div class="sp2-card-expanded-info">
              <div class="sp2-card-info-left">
                <div class="sp2-card-expanded-title">{{ item.title || '标题' }}</div>
                <div class="sp2-card-bar" />
                <div class="sp2-card-expanded-subtitle">{{ item.subtitle || '副标题' }}</div>
              </div>
              <div class="sp2-card-info-right">
                <div class="sp2-card-label">发布时间</div>
                <div class="sp2-card-time">{{ item.publishTime1 || '8月—11月' }}</div>
                <div class="sp2-card-label">发布时间</div>
                <div class="sp2-card-time">{{ item.publishTime2 || '12月20日' }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="sp2-carousel-arrow sp2-arrow-right" @click="next">
        <i class="el-icon-arrow-right" />
      </div>
    </div>

  </div>
</template>

<script>
const FIXED_DATA = [
  {
    title: '一场发展远鉴趋势论坛',
    subtitle: '2026区域农业品牌发展论坛',
    imageUrl: '',
    publishTime1: '8月—11月',
    publishTime2: '12月20日'
  },
  {
    title: '一场沉浸式品鉴体验节',
    subtitle: '一部权威年度发展报告',
    imageUrl: '',
    publishTime1: '12月18日',
    publishTime2: '12月19日-20日'
  },
  {
    title: '一场发展远鉴趋势论坛',
    subtitle: '2026区域农业品牌发展论坛',
    imageUrl: '',
    publishTime1: '8月—11月',
    publishTime2: '12月20日'
  },
  {
    title: '一场发展远鉴趋势论坛',
    subtitle: '2026区域农业品牌发展论坛',
    imageUrl: '',
    publishTime1: '8月—11月',
    publishTime2: '12月20日'
  }
]

export default {
  name: 'SpTwoModule6',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_6'
    }
  },
  data() {
    return {
      activeIndex: 1,
      backgroundColor: '#fff',
      list: FIXED_DATA.map(item => ({ ...item }))
    }
  },
  computed: {
    displayList() {
      return (this.list || []).slice(0, 4)
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      }
    }
  },
  methods: {
    prev() {
      this.activeIndex = (this.activeIndex - 1 + this.displayList.length) % this.displayList.length
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.displayList.length
    },
    setActive(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style scoped>
.sp2-module-6 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-6-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1400px;
  margin: 0 auto;
  padding: 60px 0;
  box-sizing: border-box;
}

.sp2-carousel-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  font-size: 24px;
  color: #1F48BC;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 10;
}

.sp2-carousel-list {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 21px;
  flex: 1;
}

.sp2-carousel-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 210px;
  height: 360px;
  background: #F3F6F3;
  border-radius: 10px;
  flex-shrink: 0;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp2-carousel-item.active {
  width: 606px;
  height: 394px;
  cursor: default;
}

.sp2-card-title-bg {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 209px;
  height: 90px;
  background: linear-gradient(90deg, #5E8BDF 0%, rgba(37, 78, 191, 0) 100%);
  border-radius: 10px;
  padding-left: 17px;
  box-sizing: border-box;
}

.sp2-card-title {
  width: 175px;
  height: 52px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.sp2-card-bar {
  width: 36px;
  height: 8px;
  background: linear-gradient(90deg, #1F48BC 0%, #6592E3 100%);
  border-radius: 5px;
  margin-top: 26px;
  margin-left: 17px;
  align-self: flex-start;
}

.sp2-card-subtitle {
  width: 179px;
  height: 60px;
  margin-top: 12px;
  margin-left: 17px;
  align-self: flex-start;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}

.sp2-card-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 179px;
  margin-top: 26px;
}

.sp2-card-label {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.sp2-card-time {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #1F48BC;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.sp2-card-time:not(:last-child) {
  margin-bottom: 12px;
}

.sp2-card-image-wrap {
  position: relative;
  width: 606px;
  height: 237px;
  flex-shrink: 0;
  overflow: hidden;
  background: #E0E0E0;
  line-height: 0;
  font-size: 0;
}

.sp2-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  vertical-align: top;
}

.sp2-card-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp2-card-expanded-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 446px;
  height: 59px;
  background: linear-gradient(90deg, #5E8BDF 0%, rgba(37, 78, 191, 0) 100%);
  border-radius: 0;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  padding: 0 20px 0 27px;
  box-sizing: border-box;
}

.sp2-card-expanded-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 606px;
  min-height: 121px;
  padding: 0 30px 0 0;
  box-sizing: border-box;
}

.sp2-card-info-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
}

.sp2-card-info-left .sp2-card-expanded-title {
  margin-bottom: 0;
}

.sp2-card-info-left .sp2-card-bar {
  margin-top: 27px;
  margin-left: 27px;
}

.sp2-card-expanded-subtitle {
  width: 446px;
  height: 30px;
  margin-top: 8px;
  margin-left: 27px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}

.sp2-card-info-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 19px;
}
</style>
